import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasPlayerType } from '../../../../helpers/ukPlayerTypes';


const UKDashboard = () => {
    const navigate = useNavigate();
    const { selectedClubs } = useSelector((state) => state.ukEntities);

    const hasDS = hasPlayerType(selectedClubs, 'DS');
    const hasD6 = hasPlayerType(selectedClubs, 'D6');
    const hasSelection = selectedClubs.length > 0;

    if (!hasSelection) {
        return (
            <Card className="mt-5 p-3 text-center">
                <Card.Title>Welcome to MyGymTV UK</Card.Title>
                <Card.Body>
                    <p>Please select one or more venues from the menu on the left to continue.</p>
                </Card.Body>
            </Card>
        );
    }

    return (
        <div className="uk-dashboard mt-5">
            <div className="row">
                <div className="col-md-6">
                    <Card className="p-3 text-center h-100">
                        <Card.Title>Add Content</Card.Title>
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <p className="mb-4">Upload new content for your venues</p>
                            <div className="d-flex flex-column gap-3">
                                {/*<Button*/}
                                {/*    disabled={!hasDS}*/}
                                {/*    onClick={() => navigate('/uk/add-ds')}*/}
                                {/*    variant="primary"*/}
                                {/*>*/}
                                {/*    Add DS Content*/}
                                {/*</Button>*/}
                                <Button
                                    disabled={!hasD6}
                                    onClick={() => navigate('/uk/add-d6')}
                                    variant="primary"
                                >
                                    Add D6 Content
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </div>

                <div className="col-md-6">
                    <Card className="p-3 text-center h-100">
                        <Card.Title>Review Content</Card.Title>
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <p className="mb-4">View and manage existing content</p>
                            <div className="d-flex flex-column gap-3">
                                {/*<Button*/}
                                {/*    disabled={!hasDS}*/}
                                {/*    onClick={() => navigate('/uk/review-ds')}*/}
                                {/*    variant="secondary"*/}
                                {/*>*/}
                                {/*    Review DS Content*/}
                                {/*</Button>*/}
                                <Button
                                    disabled={!hasD6}
                                    onClick={() => navigate('/uk/review-d6')}
                                    variant="secondary"
                                >
                                    Review D6 Content
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default UKDashboard;